module.exports = __webpack_public_path__ + "static/media/AccurateReporting.3bad4dd2.svg";